import { useContext } from "react";
import {useNavigate} from "react-router-dom";
import {APICreateMyMap} from "../../api/maps/Maps";
import {HiPlus} from "react-icons/hi";
import {LuFilter } from "react-icons/lu";
import {UserContext } from '../../context/UserContext';
import {EntityContext} from "../../context/EntityContext";
import {ListContext} from "../../context/ListContext";
import { GoDotFill } from "react-icons/go";


export const CardGridHeaderButton = ({text, type, limit}) => {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();

    const { setPlanAndFilesModal,currentTag, setOpenNewOrderModal } = useContext(EntityContext);
    const { setOpenTagSearchModal } = useContext(ListContext);

    const newItem = async () => {
        if (type === "map") {
            const mapId = await APICreateMyMap(user);
            if (!mapId) return;
            navigate(`/maps/${mapId}`);
        } else if (type === "order") {
            setOpenNewOrderModal(true);
        } else if (type === "plan") {
            setPlanAndFilesModal(true);
        } else if (type === "filter") {
            setOpenTagSearchModal(true);
        }
    }

    return (
        <div>
            {(limit === true) ? (
                <div className="truncate text-center inline-flex items-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-gray-600" 
                    title={"Limit erreicht"}
                >
                    <HiPlus/>
                    <span className={"hidden w-[60px] lg:w-auto lg:block pl-2"}>{text}</span>
                </div>
            ) :  (
                <div className="h-full">
                    {(type === "filter") ? (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                newItem();
                            }}
                            className="h-full truncate text-center inline-flex items-center bg-white rounded-md border-2 border-gray-500 mr-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:border-gray-600  "
                        >
                            <LuFilter/>
                            <span className={"hidden w-[60px] lg:w-auto lg:block pl-2"}>{text}</span>
                            {(currentTag !== null) && (
                                <GoDotFill className={"mb-3 text-green -mt-1 h-3 w-3"}/>
                            )}

                        </button>
                    ) : (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                newItem();
                            }}
                            className="h-full truncate text-center inline-flex items-center bg-white rounded-md border-2 border-gray-900 mr-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:border-gray-600  "
                        >
                            <HiPlus />
                            <span className={"hidden w-[60px] lg:w-auto lg:block pl-2"}>{text}</span>
                        </button>
                    )}
                </div>
            )}



        </div>

    )
}